import React, { ReactNode, useState } from 'react';

interface InfoTooltipProps {
    info: ReactNode;
    children: ReactNode;
    className?: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ info, children, className }) => {
    const [visible, setVisible] = useState(false);

    return (
        <div
            className={`relative inline-block ${className || ''}`}
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
        >
            {children}
            {visible && (
                <div className="absolute z-50 left-1/2 -translate-x-1/2 mt-2 px-3 py-2 bg-gray-800 text-white text-xs rounded shadow-lg whitespace-nowrap min-w-max">
                    {info}
                </div>
            )}
        </div>
    );
};

export default InfoTooltip;
